/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomComponents = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M5 2v3H2v2h3v12h12v3h2v-3h3v-2H7V2zm13 3H9v2h8v8h2V5zm-3.663 9.792v-1.288c-.304.101-.57.173-.8.216-.229.043-.45.064-.664.064-.485 0-.853-.152-1.104-.456-.245-.304-.368-.739-.368-1.304 0-.49.131-.88.392-1.168.267-.293.627-.44 1.08-.44.198 0 .392.019.584.056.198.032.438.09.72.176V9.352a3.298 3.298 0 0 0-1.416-.296c-.618 0-1.152.12-1.6.36s-.794.581-1.04 1.024c-.24.443-.36.97-.36 1.584 0 .987.251 1.752.752 2.296.507.539 1.22.808 2.136.808.651 0 1.214-.112 1.688-.336z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCustomComponents as CustomComponents };
